// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--R6bYJ"};